/* eslint-disable */
// ASP.NET SignalR Clássico (via CDN) - compatível com backend .NET Framework

class SignalRService {
  constructor() {
    this.connection = null;
    this.hub = null;
    this.isConnected = false;
  }

  async connect(baseUrl) {
    try {
      if (typeof $ === "undefined") {
        console.error("❌ SignalR: jQuery não está carregado!");
        return false;
      }

      // Criar conexão com ASP.NET SignalR clássico
      const signalrUrl = `${baseUrl}/signalr`;
      this.connection = $.hubConnection(signalrUrl);

      // Criar proxy para o hub
      this.hub = this.connection.createHubProxy("DeclaracoesHub");

      // Configurar eventos de conexão
      this.connection.disconnected(() => {
        this.isConnected = false;
      });

      this.connection.reconnecting(() => {
        this.isConnected = false;
      });

      this.connection.reconnected(() => {
        this.isConnected = true;
      });

      // Iniciar conexão (usar callbacks do SignalR clássico)
      await new Promise((resolve, reject) => {
        this.connection
          .start()
          .done(() => {
            this.isConnected = true;
            resolve();
          })
          .fail((error) => {
            this.isConnected = false;
            console.error("❌ SignalR: Falha ao conectar:", error);
            reject(error);
          });
      });
      return true;
    } catch (error) {
      console.error("❌ SignalR: Erro ao conectar", error);
      console.error("❌ SignalR: Detalhes:", {
        message: error.message,
        stack: error.stack,
      });
      this.isConnected = false;
      return false;
    }
  }

  onDeclaracaoAtualizada(callback) {
    if (this.hub) {
      // Registrar listener para evento de atualização
      this.hub.on("declaracaoAtualizada", (...args) => {
        callback(...args);
      });
    }
  }

  async subscribeToCliente(clienteId) {
    if (this.hub && this.isConnected) {
      try {
        // Timeout de 5 segundos
        const invokePromise = this.hub.invoke(
          "SubscribeToClienteDeclaracoes",
          clienteId,
        );
        const timeoutPromise = new Promise((_, reject) =>
          setTimeout(
            () => reject(new Error("Timeout ao inscrever (5s)")),
            5000,
          ),
        );

        await Promise.race([invokePromise, timeoutPromise]);
      } catch (error) {
        console.error("❌ SignalR: Erro ao se inscrever:", error);
        console.error(
          "❌ SignalR: Detalhes do erro:",
          error.message,
          error.stack,
        );
      }
    } else {
      console.warn(
        `⚠️ SignalR: Não conectado. Hub: ${!!this.hub}, Conectado: ${
          this.isConnected
        }`,
      );
    }
  }

  async unsubscribeFromCliente(clienteId) {
    if (this.hub && this.isConnected) {
      try {
        await this.hub.invoke("UnsubscribeFromClienteDeclaracoes", clienteId);
      } catch (error) {
        console.error("SignalR: Erro ao cancelar inscrição", error);
      }
    }
  }

  async disconnect() {
    if (this.connection) {
      try {
        this.connection.stop();
        this.isConnected = false;
      } catch (error) {
        console.error("❌ SignalR: Erro ao desconectar", error);
      }
    }
  }

  getConnectionState() {
    return this.connection?.state || "disconnected";
  }

  async trackUserNavigation(navigationData) {
    if (this.hub && this.isConnected) {
      try {
        await this.hub.invoke("TrackUserNavigation", navigationData);
      } catch (error) {
        console.error("❌ SignalR: Erro ao enviar navegação:", error);
        console.error("❌ SignalR: Detalhes:", {
          message: error.message,
          data: navigationData,
        });
      }
    } else {
      console.warn("⚠️ SignalR: Não enviado - Hub ou conexão indisponível", {
        hub: !!this.hub,
        isConnected: this.isConnected,
        connectionState: this.getConnectionState(),
      });
    }
  }

  async notifyCadastroCompleted(completionData) {
    // Se desconectou antes de enviar, reconectar temporariamente
    let reconnected = false;
    if (!this.isConnected || !this.hub) {
      console.warn(
        "⚠️ SignalR: Desconectado antes de enviar conclusão. Reconectando...",
      );
      try {
        const baseUrl =
          process.env.VUE_APP_API_URL || process.env.VUE_APP_TITLE;
        const connected = await this.connect(baseUrl);
        if (connected) {
          reconnected = true;
        } else {
          console.error(
            "❌ SignalR: Falha ao reconectar para enviar conclusão",
          );
          return;
        }
      } catch (error) {
        console.error("❌ SignalR: Erro ao reconectar para conclusão:", error);
        return;
      }
    }

    try {
      await this.hub.invoke("NotifyCadastroCompleted", completionData);
    } catch (error) {
      console.error("❌ SignalR: Erro ao notificar conclusão:", error);
      console.error("❌ SignalR: Detalhes:", {
        message: error.message,
        data: completionData,
      });
    } finally {
      // Se reconectou só para enviar, desconectar novamente
      if (reconnected) {
        await this.disconnect();
      }
    }
  }

  onNavigationTracked(callback) {
    if (this.hub) {
      this.hub.on("navigationTracked", callback);
    }
  }

  onCadastroCompleted(callback) {
    if (this.hub) {
      this.hub.on("cadastroCompleted", callback);
    }
  }
}

export default new SignalRService();
